import { defaultTheme } from '@sleepstation/themes-public-site'
import { createTheme } from '@sleepstation/utils'

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

const infoTheme = createTheme(
  `Info`,
  defaultTheme.api,
  {
    colors: {
      primaryBackground: `goldFaded`,
      primaryBackgroundStart: `goldFaded`,
      primaryBackgroundEnd: `goldFaded`,
      primaryIcon: `gold`,
    },
  },
  defaultTheme
)

export default infoTheme
